// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Defb","clinicsSelect":"TableHeading_clinicsSelect__1L5Fn"};